import { GlobalFilters } from '../GlobalFilters';

export const TopBar = () => {
  return (
    <div id="topbar" className="flex min-h-16 items-center justify-around px-4">
      <GlobalFilters />
    </div>
  );
};

TopBar.displayName = 'TopBar';
